<script>
import html2canvas from "html2canvas";

export default {
  data() {
    return {
      jp_first: "",
      jp_last: "",
      en_first: "",
      en_last: "",
      department: "",
      tel: "06-6578-5558",
      address: "",
      occupation: "",
      activeClass: "white",
      os: window.navigator.platform
    };
  },
  methods: {
    generate() {
      let component = document.querySelector(".component");
      component.style.visibility = "hidden";

      let selection = document.querySelector(".selection-group");
      selection.style.visibility = "hidden";

      let message = document.querySelector(".message_block_3");
      message.style.visibility = "hidden";
      let app = document.querySelector(".app");
      app.style.width = "1920px";
      let preview = document.querySelector("#img");
      preview.style.display = "block";
      html2canvas(preview, {
        scrollX: -window.scrollX,
        scrollY: -window.scrollY,
        scale: 1,
      }).then(function (canvas) {
        app.style.width = "";
        preview.style.display = "none";
        let result = document.querySelector("#result");
        result.innerHTML = "";
        result.appendChild(canvas);
        let img = result.firstElementChild;
        img.style.width = "960px";
        img.style.height = "540px";

        component.style.visibility = "visible";
        message.style.visibility = "visible";
        selection.style.visibility = "visible";
        let canvasTag = document.querySelector("canvas");
        let context = canvasTag.getContext("2d");
        context.scale(0.25, 0.25);
        let link = document.createElement("a");
        link.href = canvasTag.toDataURL("image/png");
        link.download = "background-image.png";
        link.click();
        result.style.display = "none";
      });
    },
    isWin() {
      this.os = "mac";
    },
  },
};
</script>

<template>
  <div class="app">
    <div class="message_block_2">
      <span class="number">01.&nbsp;</span>
      <span class="message">デザインを選んでください</span>
    </div>
    <div class="selection-group">
      <input
        id="a"
        type="radio"
        name="rate"
        v-model="activeClass"
        value="white"
      />
      <label for="a">
        <img src="../public/plan_b.png" />
      </label>

      <input
        id="b"
        type="radio"
        name="rate"
        v-model="activeClass"
        value="blue"
      />
      <label for="b">
        <img src="../public/planb_mp.png" />
      </label>

      <input
        id="c"
        type="radio"
        name="rate"
        v-model="activeClass"
        value="specialthanks"
      />
      <label for="c">
        <img src="../public/specialthanks.png" />
      </label>

      <input
        id="d"
        type="radio"
        name="rate"
        v-model="activeClass"
        value="red"
      />
      <label for="d">
        <img src="../public/sw.png" />
      </label>

      <input
        id="e"
        type="radio"
        name="rate"
        v-model="activeClass"
        value="gray"
      />
      <label for="e">
        <img src="../public/cast_me.png" />
      </label>
    </div>

    <div class="message_block_3">
      <span class="number">02.&nbsp;</span>
      <span class="message">必要事項を入力してください</span>
    </div>
    <div class="component">
      <div id="form">
        <br />
        <div class="form_department">
          <p class="form_label">所属・部署(長い場合は改行で調節してください)</p>
          <textarea
            type="text"
            class="form jp wide"
            v-model="department"
            placeholder="〇〇部 XXチーム"
            rows="4"
          />
          <br />
        </div>
        <div class="form_occupation">
          <p class="form_label">役職・職種</p>
          <input
            type="text"
            class="form jp wide"
            v-model="occupation"
            placeholder="コンサルタント"
          />
          <br />
        </div>
        <div class="form_name">
          <p class="form_label">名前</p>
          <input
            type="text"
            class="form jp"
            v-model="jp_first"
            placeholder="姓"
          />
          <input
            type="text"
            class="form jp"
            v-model="jp_last"
            placeholder="名"
          />
          <br />
        </div>
        <div class="form_yomi">
          <p class="form_label">Name</p>
          <input
            type="text"
            class="form en"
            v-model="en_first"
            placeholder="First Name"
          />
          <input
            type="text"
            class="form en"
            v-model="en_last"
            placeholder="Last Name"
          />
          <br />
        </div>
      </div>

      <br />

      <div class="sample">
        <div class="sample_image" v-bind:class="[activeClass, os]">
          <div class="sample_preview_inner">
            <div class="sample_containers" :class="[activeClass, os]">
              <div
                class="sample_name_container"
                :class="[activeClass, os]"
                v-if="jp_first != ''"
              >
                <div
                  class="sample_jp_name_container"
                  :class="[activeClass, os]"
                  v-if="jp_first != ''"
                >
                  <p class="sample_jp_name">{{ jp_first }} {{ jp_last }}</p>
                </div>
                <div
                  class="sample_en_name_container"
                  :class="[activeClass, os]"
                >
                  <p class="sample_en_name" :class="[activeClass, os]">{{ en_first }} {{ en_last }}</p>
                </div>
              </div>
              <div
                class="sample_department_container"
                :class="[activeClass, os]"
                v-if="department != ''"
              >
                <p class="sample_department" :class="[activeClass, os]">{{ department }}</p>
              </div>
              <div
                class="sample_occupation_container"
                :class="[activeClass, os]"
                v-if="occupation != ''"
              >
                <p class="sample_occupation" :class="[activeClass, os]">{{ occupation }}</p>
              </div>
            </div>
          </div>
        </div>
        <button class="button" v-on:click="generate">
          <p class="generate_button">画像をダウンロード</p>
        </button>
      </div>
    </div>

    <div id="preview">
      <div id="img" class="preview_inner" v-bind:class="[activeClass, os]">
        <div class="containers" v-bind:class="[activeClass, os]">
          <div
            class="name_container"
            :class="[activeClass, os]"
            v-if="jp_first != ''"
          >
            <div
              class="jp_name_container"
              :class="[activeClass, os]"
              v-if="jp_first != ''"
            >
              <p class="jp_name">{{ jp_first }} {{ jp_last }}</p>
            </div>
            <div class="en_name_container" :class="[activeClass, os]">
              <p class="en_name">{{ en_first }} {{ en_last }}</p>
            </div>
          </div>
          <div
            class="department_container"
            :class="[activeClass, os]"
            v-if="department != ''"
          >
            <p class="department" :class="[activeClass, os]">{{ department }}</p>
          </div>
          <div
            class="occupation_container"
            :class="[activeClass, os]"
            v-if="occupation != ''"
          >
            <p class="occupation" :class="[activeClass, os]">{{ occupation }}</p>
          </div>
        </div>
      </div>
    </div>

    <p class="p"></p>
    <div id="result"></div>
  </div>
</template>

<style scoped>
div {
  text-align: center;
}

.preview_inner {
  background-size: contain;
  position: relative;
  padding-bottom: 1080px;
  width: 1920px;
  display: none;
}

.red {
  background: url(../public/sw.png) no-repeat left bottom;
}

.white {
  background: url(../public/plan_b.png) no-repeat left bottom;
}

.gray {
  background: url(../public/cast_me.png) no-repeat left bottom;
}

.blue {
  background: url(../public/planb_mp.png) no-repeat left bottom;
}

.specialthanks {
  background: url(../public/specialthanks.png) no-repeat left bottom;
}

.sample_image {
  background-size: contain;
  position: relative;
  width: 800px;
  height: 450px;
}

label img {
  margin: 10px;
  padding: 8px;
  width: 250px;
  height: 140px;
  border: 2px;
  border-style: solid;
  border-color: #eee;
  cursor: pointer;
}
</style>
